import React from "react";
import "./Service.css";
import services_logo from "../../assets/services/services_logo.png";
import hive_page_logo from "../../assets/allpages/hive_page_logo.png";
import web_dev_logo from "../../assets/services/images/web_dev.png";
import web_design from "../../assets/services/images/web_design.png";
import gfx_vfx from "../../assets/services/images/gfx_vfx.png";
import brand_iden from "../../assets/services/images/brand_iden.png";
import fivem_redm from "../../assets/services/images/fivem_redm.png";

const Service = () => {
  return (
    <div className="services_page" id="service">
      <div className="services_container">
        <div className="services_top">
          <div className="left_services_top">
            <img src={services_logo} alt="HiveTeam services" />
            <p>
              Oferim servicii complete de web development si branding pentru
              companii care vor sa creasca online. Lucram frecvent cu business-
              uri din design interior, amenajari interioare si arhitectura.
            </p>
          </div>
          <img className="hive_allpages" src={hive_page_logo} alt="HiveTeam" />
        </div>

        <div className="services_center">
          <div className="service_box">
            <h1>Web Development</h1>
            <p>
              Construim website-uri rapide, scalabile si optimizate SEO pentru
              servicii premium si lead generation.
            </p>
            <img src={web_dev_logo} alt="Web development service" />
          </div>
          <div className="service_box">
            <h1>Web Design</h1>
            <p>
              Design modern, orientat pe conversii, cu focus pe portofolii,
              servicii si prezentare profesionala.
            </p>
            <img src={web_design} alt="Web design service" />
          </div>
          <div className="service_box">
            <h1>Brand Identity</h1>
            <p>
              Definim identitate vizuala clara: logo, paleta cromatica, directie
              vizuala si consistenta de brand.
            </p>
            <img src={brand_iden} alt="Brand identity service" />
          </div>
          <div className="service_box">
            <h1>GFX/VFX</h1>
            <p>
              Materiale vizuale pentru campanii, social media si prezentari de
              brand cu impact.
            </p>
            <img src={gfx_vfx} alt="GFX and VFX service" />
          </div>

          <div className="service_box">
            <h1>FiveM Development</h1>
            <p>
              Dezvoltare custom pentru comunitati FiveM, sisteme server-side si
              optimizari de performanta.
            </p>
            <img src={fivem_redm} alt="FiveM development service" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Service;
